import { Role } from "@/acl/roles";
import { GenericProductCards } from "@/assets/constants/analysisCards";
import { GLOBAL_EVENTS } from "@/assets/constants/eventsDates";
import { UpdateFrequency } from "@/assets/constants/frequencies";
import {
  STANDARD_PERF_STATS_WITH_BENCHMARK,
  STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
} from "@/assets/constants/perfStats";
import { STANDARD_ZOOM_BUTTONS } from "@/assets/constants/zoomButtons";
import exports from "@/assets/scss/exports.module.scss";

const ORG_COLOR = exports["colors-primary"];
const INTERNAL_ALLOWED_ROLES = [Role.admin, Role.superAdmin];

const trackerNexusCapitalAmc = {
  productId: "tracker-nexus-capital-amc",
  storeModule: "trackerNexusCapitalAmc",
  productName: "Tracker - Nexus Capital AMC",
  productShortName: "Tracker - Nexus Capital",
  productColor: ORG_COLOR,
  allowPriceDataModification: true,
  live: {
    updateFrequency: UpdateFrequency.monthly,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.drawdowns,
      GenericProductCards.volatility,
    ],
    perfStats: STANDARD_PERF_STATS_WITHOUT_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet" },
      allowedRoles: INTERNAL_ALLOWED_ROLES,
    },
  ],
};

const valcoreFlagshipGrowthStrategyChf = {
  productId: "valcore-flagship-growth-strategy-chf",
  storeModule: "valcoreFlagshipGrowthStrategyChf",
  productName: "Valcore Flagship - Growth Strategy (CHF)",
  productColor: ORG_COLOR,
  allowPriceDataModification: true,
  allowHoldingDataModification: true,
  live: {
    updateFrequency: UpdateFrequency.monthly,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.drawdowns,
      GenericProductCards.volatility,
    ],
    perfStats: STANDARD_PERF_STATS_WITH_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet" },
      allowedRoles: INTERNAL_ALLOWED_ROLES,
    },
  ],
};

const asymmetricCoreSatelliteStrategy = {
  productId: "asymmetric-core-satellite-strategy",
  storeModule: "asymmetricCoreSatelliteStrategy",
  productName: "Growth Mandate",
  productColor: ORG_COLOR,
  allowPriceDataModification: true,
  allowHoldingDataModification: true,
  live: {
    updateFrequency: UpdateFrequency.monthly,
    zoomButtons: STANDARD_ZOOM_BUTTONS,
    genericCardsToShow: [
      GenericProductCards.cumulativeReturns,
      GenericProductCards.performanceStats,
      GenericProductCards.drawdowns,
      GenericProductCards.volatility,
    ],
    perfStats: STANDARD_PERF_STATS_WITH_BENCHMARK,
    events: GLOBAL_EVENTS,
  },
  reports: [
    {
      id: "factsheet",
      langToName: { en: "Factsheet" },
      allowedRoles: INTERNAL_ALLOWED_ROLES,
    },
  ],
};

export const PRODUCTS_DETAILS = [
  trackerNexusCapitalAmc,
  valcoreFlagshipGrowthStrategyChf,
  asymmetricCoreSatelliteStrategy,
];

export const PRODUCTS = PRODUCTS_DETAILS.map((details) => details.storeModule);
